const productsSpecsSection = $('#specs-section');
const specsCards = $('.spec-card-parent');

const addCardsLineAnimation = (element) => {
  const lines = element.find('.spec-item-line');
  const linesTL = gsap.timeline({ paused: true });
  linesTL.add(
    gsap.to(lines, {
      width: '100%',
      duration: 1,
      ease: 'pageInEasing',
      stagger: {
        each: 0.1,
      },
    })
  );
  return linesTL;
};

const addSpecsAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const specsTL = gsap.timeline({ paused: true });

  const specsTopperTL = gsap.timeline({ paused: true });

  specsTopperTL.add(
    animateSectionTopperIn({
      sectionParent: productsSpecsSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  specsTL.add(elementInAnimationYWOpacity(specsCards, '15vw', 0, 1, 1.03, 0.87, 0, 0.1).play(), 0.16);

  specsCards.each(function (index) {
    //specsTL.add(addElementIn($(this), `15vw`, 1.03, 'pageInEasing').play(), 0.16 + 0.1 * index);
    specsTL.add(addCardsLineAnimation($(this)).play(), 0.66 + 0.1 * index);
  });

  return [specsTL, specsTopperTL];
};

const initProductsSpecs = () => {
  const [specsTL, specsTopperTL] = addSpecsAnimation();

  ScrollTrigger.create({
    trigger: productsSpecsSection,
    start: 'top top+=120%',
    end: 'top+=10% top',
    once: true,
    onUpdate: (self) => {
      specsTopperTL.progress(self.progress);
    },
  });
  ScrollTrigger.create({
    trigger: productsSpecsSection,
    start: 'top top+=100%',
    end: 'top+=10% top',
    once: true,
    onEnter: () => {
      //specsTL.play();
    },
    onUpdate: (self) => {
      specsTL.progress(self.progress);
    },
  });
}

/*
$(window).on('load', () => {
  initProductsSpecs();
});
*/

addSectionObserver(productsSpecsSection, initProductsSpecs, false);